import React from 'react'
import { LogOut } from 'lucide-react'
import { Avatar } from '@/components/admin/atoms/feedback/Avatar'
import { DropdownAnchor } from '@/components/admin/atoms/layout/DropdownAnchor'
import { DropdownMenu } from '@/components/admin/atoms/layout/DropdownMenu'
import { DropdownMenuLink } from '@/components/admin/atoms/navigation/DropdownMenuLink'
import { IconSlot } from '@/components/admin/atoms/layout/IconSlot'

interface UserMenuProps {
  initials: string
  open: boolean
  onToggle: () => void
  anchorRef: React.RefObject<HTMLDivElement>
  className?: never
}

const iconStyle = { width: 16, height: 16 }

export const UserMenu: React.FC<UserMenuProps> = ({
  initials,
  open,
  onToggle,
  anchorRef,
}) => (
  <DropdownAnchor ref={anchorRef}>
    <Avatar initials={initials} size="sm" onClick={onToggle} clickable />
    <DropdownMenu open={open}>
      <DropdownMenuLink href="/auth/logout" method="delete" as="button">
        <IconSlot><LogOut style={iconStyle} /></IconSlot>
        Logout
      </DropdownMenuLink>
    </DropdownMenu>
  </DropdownAnchor>
)
